import { userInfoStore } from './store/userInfo';
import { chainListStore } from './store/chainList';
import { userWalletStore } from './store/userWallet';
import { thirdPartyWallet } from './wallet-hub/Web3WalletHubCenter';
import { enableDebugging } from './utils/common';

if (typeof window !== 'undefined') {
  window.__web3Infra = {
    userWalletStore,
    thirdPartyWallet,
    enableDebugging,
    chainListStore,
    userInfoStore,
  };
}
